import script from "./TicketTv.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketTv.vue?vue&type=script&setup=true&lang=js"

import "./TicketTv.vue?vue&type=style&index=0&id=3fae4fb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fae4fb8"]])

export default __exports__